import { isEmpty, find, includes, get } from 'lodash';
import { transformValuesToString, encodeTextAnswers } from './utils';
import {
  PROFILING_DISQUALIFICATION,
  TRANSFORMATION_DATA_TYPE_JSON,
} from './constants';
import request from './request';

Pollfish.profiling = (function profiling() {
  let profilingQuestions = [];
  let answeredQuestions = [];
  let savedAnswers = [];
  let isDisqualified = false;
  let hasAnsweredAllProfiling = false;
  let disqualifyImmediately = false;
  let disqualificationData = {};
  return {
    setQuestions(questions = []) {
      profilingQuestions = questions.map((question) => ({
        ...question,
        isProfilingQuestion: true,
      }));

      isDisqualified = false;
      if (isEmpty(questions)) {
        hasAnsweredAllProfiling = true;
      } else {
        hasAnsweredAllProfiling = false;
      }

      // we can refrain from deleting those if we want to keep history
      savedAnswers = [];
      answeredQuestions = [];
    },
    reset() {
      answeredQuestions = [];
      savedAnswers = [];
      isDisqualified = false;
      hasAnsweredAllProfiling = false;
      disqualifyImmediately = false;
      disqualificationData = {};
      if (isEmpty(profilingQuestions)) {
        hasAnsweredAllProfiling = true;
      } else {
        hasAnsweredAllProfiling = false;
      }
      // we can refrain from deleting those if we want to keep history
      savedAnswers = [];
      answeredQuestions = [];
    },
    getQuestions() {
      return profilingQuestions;
    },
    isPending() {
      return !isEmpty(profilingQuestions) && !hasAnsweredAllProfiling;
    },
    isCompleted() {
      return isEmpty(profilingQuestions) || hasAnsweredAllProfiling;
    },
    getNextQuestion() {
      // if (isDisqualified && disqualifyImmediately) {
      //   return null;
      // }
      const pendingQuestion = find(
        profilingQuestions,
        (question) => !includes(answeredQuestions, question.id),
      );
      return pendingQuestion;
    },
    getQuestionByRefId(refId) {
      return find(profilingQuestions, ['refId', refId]);
    },
    getQuestionById(id) {
      return find(profilingQuestions, ['id', id]);
    },
    getDisqualificationReason() {
      return disqualificationData.reason;
    },
    getDisqualificationData() {
      return disqualificationData;
    },
    setDisqualified(value, question, selectedAnswers) {
      disqualificationData = {
        question,
        selectedAnswers,
        reason: PROFILING_DISQUALIFICATION,
      };
      disqualifyImmediately = false;
      isDisqualified = value;
    },
    isDisqualified() {
      return isDisqualified;
    },
    shouldDisqualifyImmediately() {
      return disqualifyImmediately;
    },
    saveAnswer(requestObject) {
      // NOTE: we can check here if a user has already answered the given question!
      // or at least if we know it since we keep it in-memory
      const answeredQuestion = requestObject.q_id;
      if (!answeredQuestion) {
        throw new Error('Missing answered question from request object');
      }
      // we save these answers so that the backend will receive them all together
      // but the backend expects their values as strings s_id, ttc etc
      savedAnswers.push(
        encodeTextAnswers(transformValuesToString(requestObject)),
      );
      answeredQuestions.push(answeredQuestion);

      if (answeredQuestions.length === profilingQuestions.length) {
        hasAnsweredAllProfiling = true;
      }
      // send the selected answer to the server
      request({
        url: '/v2/device/set/profiling/question/answered',
        method: 'POST',
        contentType: 'application/json; charset=utf-8',
        transformData: true,
        transformationDataType: TRANSFORMATION_DATA_TYPE_JSON,
        data: requestObject,
      });
    },
    getStoredAnswers() {
      return savedAnswers;
    },
    getProfilingAnswersAsQueryString() {
      // generate the profiling "qualifying" answers query parameter, the format is
      // "profiling_100=1000&profiling_100=1001&profiling_101=1002"
      let profilingAnswersString = savedAnswers.map(
        (profilingAnsweredQuestion) => {
          let profilingAnsweredQuestionId = profilingAnsweredQuestion.q_id;
          const { answers = [] } = profilingAnsweredQuestion;
          if (typeof profilingAnsweredQuestionId === 'string') {
            profilingAnsweredQuestionId = parseInt(
              profilingAnsweredQuestionId,
              10,
            );
          }
          const matchedProfilingQuestion = this.getQuestionById(
            profilingAnsweredQuestionId,
          );
          const matchedProfilingQuestionAnswers = get(
            matchedProfilingQuestion,
            'answers',
            [],
          );
          const questionAnswers = answers.map((answer) => {
            const isQualifyingAnswer = find(
              matchedProfilingQuestionAnswers,
              (ans) => ans.disqualifies !== true && ans.id === answer.id,
            );
            return isQualifyingAnswer
              ? `&p_${profilingAnsweredQuestionId}=${answer.id}`
              : '';
          });
          return questionAnswers.join('');
        },
      );
      profilingAnswersString = profilingAnswersString.join('').slice(1);
      return profilingAnswersString;
    },
  };
})();

export default Pollfish.profiling;
